import { render, staticRenderFns } from "./AuthorizationLine.vue?vue&type=template&id=10c53364&scoped=true&"
import script from "./AuthorizationLine.vue?vue&type=script&lang=js&"
export * from "./AuthorizationLine.vue?vue&type=script&lang=js&"
import style0 from "./AuthorizationLine.vue?vue&type=style&index=0&id=10c53364&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c53364",
  null
  
)

export default component.exports